/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import {convertToItems} from '../../common/utilities';
import InputList from '../../containers/disponent/input-list.js';
import Button from '../../components/task/shop/form/button';
import {getUsers} from "../../store/dispo/selectors";
import {getTasksCurrent} from "../../store/tasks/selectors";

const WrapperWrapper = styled.div`
	background: #fff;
	padding: 13px 19px;
	border-radius: 8px;
	border: 1px solid #d9d7d7;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
`;

const UsersInput = ({
                        data,
                        handleSelect,
                        users,
                        handleComplete,
                        currentTask,
                        departmentViewValue,
                    }) => {
    const pluckStepNumber = (val) => val.id;
    const pluckStepValue = (val) => {
        return {value: val.id, viewValue: val.fullname}
    };
    const inDepartment = user => {
        if (R.isNil(user.departmentId) || R.isEmpty(user.departmentId)) return true;
        return !R.isNil(R.find((name) => user.departmentId === name || user.department === name)(departmentViewValue));
    };

    return (
        <WrapperWrapper>
            <InputList
                items={convertToItems(
                    R.filter(inDepartment, users),
                    data.value,
                    (item, val) => pluckStepNumber(item) === val
                )}
                handleClick={(val) => handleSelect(pluckStepValue(val))}
                currentTask={currentTask}
            />

            <Button handleClick={() => handleComplete(data)} width="100%"/>
        </WrapperWrapper>
    );
};

export default connect(
    (state) => ({
        users: getUsers(state),
        currentTask: getTasksCurrent(state),
    })
)(UsersInput);



// WEBPACK FOOTER //
// ./src/containers/disponent/users-input.js